import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { isAdminOnlyUser } from '../types/roles';

/**
 * Smart redirect component for root path (/).
 * - Admin-only users → /admin
 * - Checks localStorage for admin return URL before redirecting to chat.
 * - Uses localStorage (not sessionStorage) to survive the MSAL redirect flow.
 */
const RootRedirect: React.FC = () => {
  const { user } = useAuth();

  // Check localStorage SYNCHRONOUSLY during render (before any effects run)
  const adminReturnUrl = localStorage.getItem('adminReturnUrl');
  
  // Clean up localStorage AFTER navigation (in effect, not during render)
  useEffect(() => {
    if (adminReturnUrl && adminReturnUrl.startsWith('/admin')) {
      console.log('RootRedirect: Cleaning up adminReturnUrl after redirect');
      localStorage.removeItem('adminReturnUrl');
    }
  }, [adminReturnUrl]);

  // Admin-only users always go to admin portal
  if (isAdminOnlyUser(user?.roles)) {
    return <Navigate to="/admin" replace />;
  }
  
  if (adminReturnUrl && adminReturnUrl.startsWith('/admin')) {
    return <Navigate to={adminReturnUrl} replace />;
  }

  return <Navigate to="/chat" replace />;
};

export default RootRedirect;
